import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleTypeOfFundObject } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheFundComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const fundCombo = computed(() => {
    const funds = store.getters[`${ModuleTypeOfFundObject}/items`];
    return funds.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheFundComboConfig = reactive({
    data: fundCombo,
    columns: [
      {
        title: 'Mã loại quỹ',
        dataField: 'fund_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại quỹ',
        dataField: 'fund_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'fund_code',
    valueField: 'fund_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'fund_id',
      titleSearch: 'Tìm nhanh loại quỹ',
    },
  });

  return {
    cacheFundComboConfig,
  };
};
